module.exports = __webpack_public_path__ + "img/sticker_2.157a266d.svg";